import { UseHSTableReturnType } from '../hooks/useHSTable'

export const defaultHSTable: UseHSTableReturnType = {
  tableData: [],
  searchValue: '',
  sortParams: undefined,
  firstLoad: true,
  totalNumber: 0,
  pageInfo: { pageNumber: 1, pageSize: 10 },
  debouncedSearch: '',
  handleTableChange: () => undefined,
  handleChangePageSize: () => undefined,
  setSearchValue: () => undefined,
  getTableData: () => undefined,
  refreshTableData: () => Promise.resolve(),
  expandedRowKeys: [],
  setExpandedRowKeys: () => undefined
}
